import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import { BookingWizardDataAtom } from "../../stores";

export const CourseLayoutSelectorAtom = atom<BookingWizard.CourseLayout | null>(
  (get) => {
    const bookingWizardData = get(BookingWizardDataAtom);

    return bookingWizardData?.type === "GolfBooking" &&
      bookingWizardData?.courseLayout
      ? bookingWizardData?.courseLayout
      : null;
  }
);
